import { render, staticRenderFns } from "./ModalUserDeleteConfirmation.vue?vue&type=template&id=0757984d&scoped=true"
import script from "./ModalUserDeleteConfirmation.vue?vue&type=script&lang=js"
export * from "./ModalUserDeleteConfirmation.vue?vue&type=script&lang=js"
import style0 from "./ModalUserDeleteConfirmation.vue?vue&type=style&index=0&id=0757984d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0757984d",
  null
  
)

export default component.exports